<template>
  <fieldset class="p-fieldset p-form-element">
    <legend>{{ label }}</legend>
    <slot></slot>
  </fieldset>
</template>

<script lang="ts">
  import Vue from 'vue';

  export default Vue.extend({
    name: 'PFieldset',
    props: {
      label: { type: String, default: undefined },
    },
    data: () => ({

    }),
  });
</script>
